import { render, staticRenderFns } from "./AccesoComponent.vue?vue&type=template&id=3edfe496"
import script from "./AccesoComponent.vue?vue&type=script&lang=js"
export * from "./AccesoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports